import React, { useRef, useState } from 'react';
import s from './s.module.less';
import { Button, Spin } from 'antd';
import ProviderStore from 'store/Provider';
import SubscriptionStore from 'store/Subscription';
import HomeStore from 'store/Home';
import { TServerMessage } from 'types/inbox';
import { handleServerSideMessage, unitAndSortServerMessages } from 'utils/inbox';
import { getOpsConversationMessageList, TOpsGetConversationMessageList } from 'api/operation';
import InboxMessageList from 'pages/dashboard/InboxPage/MessageContainer/components/InboxMessageList';
import { TextVisitCase } from 'types/textVisit';

type Props = {
    clientId?: number;
    providerId?: number;
    isOps?: boolean;
    caseData?: TextVisitCase;
};
const DEFAULT_FETCH_MESSAGE_COUNT = 30;
const LOAD_HISTORY_INTERVAL = 1000 * 2;

const HistoryMessage = (props: Props) => {
    const { clientId, providerId, isOps, caseData } = props;
    const [get] = ProviderStore.useStore();
    const [getSubscription] = SubscriptionStore.useStore();
    const [getHomeSore] = HomeStore.useStore();
    const homeInfo = getHomeSore('data');
    const [messageList, setMessageList] = useState<TServerMessage[]>();
    const [loadingConversationMessage, setLoadingConversationMessage] = useState<boolean>(false);
    const latestConversationMessageCursor = React.useRef<string>();
    const latestLoadHistoryTime = React.useRef<number>(new Date().getTime());
    const loadingHistoryMessageRef = useRef<boolean>(false);
    const conversationMessageRef = React.useRef<TServerMessage[] | undefined>();
    const allMessageFetchedFlag = React.useRef<boolean>(false);
    const [, forceUpdate] = useState<{}>();

    const scrollToLatestMessage = (timeout?: number, smooth?: boolean) => {
        setTimeout(() => {
            const messageWrap = document.getElementById('clientMessageWrap');
            if (messageWrap) {
                messageWrap.scrollTo({
                    top: 99999,
                    behavior: smooth ? 'smooth' : 'auto',
                });
            }
        }, timeout || 150);
    };

    const fetchMessage = async (cursor?: string, size?: number) => {
        if (!providerId || !clientId) {
            return;
        }
        const param: TOpsGetConversationMessageList = {
            clientId,
            providerId,
            size: 10 || 50,
        };
        if (cursor) {
            param.cursor = cursor;
        }
        setLoadingConversationMessage(true);
        const res = await getOpsConversationMessageList(param);
        if (!res.error) {
            const data = res?.data?.data?.items || [];
            const isEmpty = data.length === 0;
            const _cursor = res?.data?.data?.cursor;
            const currentCursor = latestConversationMessageCursor.current || '';
            if (!currentCursor || cursor) {
                //mean loading history or loading new but with any cursor
                latestConversationMessageCursor.current = _cursor || '';
            }
            if (isEmpty) {
                allMessageFetchedFlag.current = true;
            }

            const cacheMessageList = conversationMessageRef.current || [];
            const _message = unitAndSortServerMessages([...(cacheMessageList || []), ...data]);
            conversationMessageRef.current = _message || [];
            setMessageList(_message);
            if (!cursor) {
                scrollToLatestMessage();
            }
        }
        setLoadingConversationMessage(false);
    };

    const loadHistoryMessage = async () => {
        if (loadingHistoryMessageRef.current === true) {
            return;
        }
        const cursor = latestConversationMessageCursor.current || '';
        if (!cursor) {
            return;
        }

        const allLoad = allMessageFetchedFlag.current;
        if (allLoad) {
            return;
        }
        const nowTime = new Date().getTime();
        const latestLoadTime = latestLoadHistoryTime.current;
        const diff = nowTime - latestLoadTime;
        if (diff < LOAD_HISTORY_INTERVAL) {
            return;
        }
        latestLoadHistoryTime.current = nowTime;
        loadingHistoryMessageRef.current = true;
        forceUpdate({});
        await fetchMessage(cursor, DEFAULT_FETCH_MESSAGE_COUNT);
        loadingHistoryMessageRef.current = false;
        forceUpdate({});
    };

    React.useEffect(() => {
        console.log({
            providerId,
            clientId,
        });
        if (!providerId || !clientId) {
            return;
        }
        fetchMessage();
        const messageWrap = document.getElementById('clientMessageWrap');
        const messageScrollCheck = (e: Event) => {
            const target = e.target as HTMLElement;
            const { scrollTop } = target;
            if (scrollTop === 0) {
                loadHistoryMessage();
            }
        };
        if (messageWrap) {
            messageWrap.addEventListener('scroll', messageScrollCheck);
        }

        return () => {
            if (messageWrap) {
                messageWrap.removeEventListener('scroll', messageScrollCheck);
            }
        };
    }, [providerId, clientId]);

    const displayMessage = handleServerSideMessage(messageList, 0);
    // need conversion
    //     firstName = inboxConversation?.patientFirstName || '';
    //     lastName = inboxConversation?.patientLastName || '';
    // } else if (inboxMessage?.senderType === 'PROVIDER') {
    //     firstName = inboxConversation?.providerFirstName || '';
    //     lastName = inboxConversation?.providerLastName || '';
    return (
        <div className={`${s.wrap}`}>
            <div className={s.wrapper} id="clientMessageWrap">
                {/* {loadingHistoryMessageRef.current && <Spin className={s.messageLoadingHistory} />} */}
                {!allMessageFetchedFlag.current && (
                    <div className={s.loadmore}>
                        <Button
                            type="primary"
                            size="small"
                            onClick={loadHistoryMessage}
                            loading={loadingHistoryMessageRef.current}
                        >
                            Load more
                        </Button>
                    </div>
                )}

                <InboxMessageList
                    inboxMessageList={displayMessage}
                    inboxConversation={
                        {
                            patientFirstName: caseData?.patientFirstName || '',
                            patientLastName: caseData?.patientLastName || '',
                            providerFirstName: caseData?.assignedProviderFirstName || '',
                            providerLastName: caseData?.assignedProviderLastName || '',
                        } as any
                    }
                />
                {loadingConversationMessage && !loadingHistoryMessageRef.current && (
                    <Spin className={s.messageLoading} />
                )}
            </div>
        </div>
    );
};

export default HistoryMessage;
